/** 报警设置 */
import './index.scss'
import React from 'react';
import {Button} from 'antd';
import ComTable from './components/ComTable'

class header extends React.Component{
  state = {
  };
  render() {
    return (
      <div className='page-alarm-setting card'>
        <div className="mBtm15" style={{float: "right"}}>
          <Button type="primary">新增项目</Button>
        </div>
        <ComTable />
      </div>
    );
  }
};
export default header;
